import { useTranslation } from 'react-i18next'
import { Activity, SubmissionType } from '@cms-max/medicare-api-sdk'

import { MyDialog } from 'components/MyDialog'

import { ConfirmPasswordForm } from '../PasswordForm/ConfirmPasswordForm'
import { PasswordModalForm } from './PasswordModalForm'
import { useUpdateAccountHandler } from 'hooks/useUpdateAccountHandler'
import { EditPasswordFormData } from 'models/forms/PasswordForm'
import { setLastUpdated } from 'redux/reducers/users'
import { Dispatch } from 'react'
import { useModalCloseEvent } from 'components/MyDialog/useModalCloseEvent'

export type PasswordModalProps = {
  onClose: () => void
}

const transformFormDataToRequestData = (formData: EditPasswordFormData) => ({
  password: formData.password
})

const handleSuccessfulUpdate = (dispatch: Dispatch<any>, _formData: EditPasswordFormData) => {
  dispatch(setLastUpdated({ key: 'password' }))
}

export const PasswordModal = ({ onClose }: PasswordModalProps) => {
  const trackSLSActivity = (respStatus: string) => {
    window.globalHeaderEvents?.handleEvent({
      core: {
        activity: Activity.DownstreamServiceResponse,
        component: 'Account Settings',
        property: 'MAX',
        elementId: 'accountsettings_password_response',
        additionalData: {
          result: respStatus
        },
        submissionType: SubmissionType.Update
      }
    })
  }

  const { handleSubmit, loading, serverErrors, password, setPassword } = useUpdateAccountHandler<EditPasswordFormData>(
    { onClose, trackSLSActivity, transformFormDataToRequestData, handleSuccessfulUpdate }
  )

  const { t } = useTranslation('editPassword')

  const handleClose = useModalCloseEvent('accountSettings', 'accountsettings_password_close', onClose)

  return (
    <MyDialog
      heading={t('heading')}
      containerId="medicare-my-acct-password-settings"
      closeButtonAriaLabel={t('Close')}
      onClose={handleClose}
    >
      <>
        {!password
          ? (
          <>
            <p>{t('verifyText')}</p>
            <ConfirmPasswordForm
              onSubmit={setPassword}
              onClose={onClose}
            />
          </>
            )
          : (
          <PasswordModalForm
            loading={loading}
            onClose={handleClose}
            onSubmit={handleSubmit}
            serverErrors={serverErrors}
          />
            )}
      </>
    </MyDialog>
  )
}
